const updates = [
  {
    date: '2026-07-29',
    title: '全新「每日大赛」赛制升级上线',
    desc: '每日大赛板块全面升级，新增话题 PK 模式和用户投票机制，让热点讨论更加激烈和有趣。升级后首日参与人数突破 50 万。',
    tag: '产品更新',
  },
  {
    date: '2026-07-27',
    title: '体育圈转会季专题上线',
    desc: '针对夏季转会窗口，51爆料特别推出「体育圈转会季」专题页面，实时追踪各大联赛转会动态，汇总多方消息源。',
    tag: '新专题',
  },
  {
    date: '2026-07-25',
    title: '平台月活用户突破 800 万',
    desc: '51爆料月度活跃用户数再创新高，正式突破 800 万大关。感谢每一位用户的支持与信任，我们将持续优化内容质量与产品体验。',
    tag: '里程碑',
  },
  {
    date: '2026-07-22',
    title: '移动端 3.0 版本正式发布',
    desc: 'iOS 和 Android 客户端同步推送 3.0 大版本更新，全新 UI 设计、更快的加载速度、智能推送算法全面优化。',
    tag: '产品更新',
  },
  {
    date: '2026-07-20',
    title: '内容审核机制升级公告',
    desc: '为进一步提升内容质量，平台已升级 AI+人工双重审核机制，所有爆料内容发布前均经过严格核实流程，确保信息可靠性。',
    tag: '平台公告',
  },
  {
    date: '2026-07-17',
    title: '「财经热点速递」频道全新开播',
    desc: '51爆料与多家财经媒体达成内容合作，全新推出财经热点速递频道，每日精选资本市场最新动态与深度分析。',
    tag: '新频道',
  },
  {
    date: '2026-07-14',
    title: '社区互动功能全面开放',
    desc: '评论区升级为社区互动系统，支持点赞、回复嵌套、热门评论置顶等功能，用户互动体验大幅提升。',
    tag: '产品更新',
  },
  {
    date: '2026-07-11',
    title: '「海外爆料精选」频道上线',
    desc: '新增海外爆料精选频道，覆盖国际热点、海外趣闻、跨境话题，为用户提供全球化视角的每日爆料内容。',
    tag: '新频道',
  },
  {
    date: '2026-07-08',
    title: '51爆料品牌全面升级',
    desc: '51爆料完成品牌视觉与定位全面升级，新 slogan「爆点不断·热度不散」正式启用，标志着平台进入全新发展阶段。',
    tag: '里程碑',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            平台动态
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            51爆料最新动向与更新记录，不错过每一次升级
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-0 top-0 bottom-0 w-px bg-background-300"></div>

            <div className="space-y-8">
              {updates.map((item, i) => (
                <div key={i} className="relative pb-2">
                  <div className="absolute -left-[33px] md:-left-[37px] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}